// extracted by css-extract-rspack-plugin
export default {"bonus-content-wrapper":"BonusesCard-module__bonus-content-wrapper--lVsCc","bonusContentWrapper":"BonusesCard-module__bonus-content-wrapper--lVsCc"};